import React, { useEffect, useState } from 'react';
import { initMetaPixel, trackPageView, trackViewContent } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { RevelationSection } from '../components/RevelationSection';
import { ValueStack } from '../components/ValueStack';
import { IsForYouSection } from '../components/IsForYouSection';
import { Testimonials } from '../components/Testimonials';
import { OrderBump } from '../components/OrderBump';
import { FinalOffer } from '../components/FinalOffer';
import { FAQ } from '../components/FAQ';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
import { StickyCTA } from '../components/StickyCTA';
export function LandingPage() {
  const [isOrderBumpChecked, setIsOrderBumpChecked] = useState(false);
  useEffect(() => {
    initMetaPixel();
    trackPageView();
    trackViewContent();
  }, []);
  return <main className="min-h-screen w-full bg-cream font-sans text-brown selection:bg-forest/20" data-id="element-276">
      <HeroSection data-id="element-277" />
      <PainSection data-id="element-278" />
      <RevelationSection data-id="element-279" />
      <IsForYouSection data-id="element-280" />
      <ValueStack data-id="element-281" />
      <Testimonials data-id="element-282" />

      <FinalOffer isOrderBumpChecked={isOrderBumpChecked} data-id="element-283" />

      {/* Order Bump below Resumen de Inversión */}
      <section className="bg-cream pt-4 pb-10" data-id="element-284">
        <div className="max-w-3xl mx-auto px-4" data-id="element-285">
          <OrderBump isChecked={isOrderBumpChecked} onToggle={() => setIsOrderBumpChecked(!isOrderBumpChecked)} data-id="element-286" />
        </div>
      </section>
      <FAQ data-id="element-287" />

      <RecentPurchaseToast data-id="element-288" />
      <StickyCTA isOrderBumpChecked={isOrderBumpChecked} data-id="element-289" />

      <footer className="bg-brown text-parchment/60 py-8 text-center text-sm pb-24" data-id="element-290">
        <p data-id="element-291">
          © {new Date().getFullYear()} Botiquín Ancestral. Todos los derechos
          reservados.
        </p>
        <p className="mt-2 text-xs opacity-50" data-id="element-292">
          Este manual te enseña el rol de apoyo de la medicina natural — sin
          reemplazar emergencias médicas
        </p>
      </footer>
    </main>;
}